<template>
  <div>
    <Navbar />
    <router-view></router-view>
    <Footer />
  </div>
</template>

<script>
import Navbar from '@/component/navbar/Navbar'
import Footer from '@/component/footer/Footer'

export default {
  components: {
    Navbar,
    Footer
  }
}
</script>
<style lang="scss">
@import '@/css/app.scss';
</style>
